module.exports = "/_next/static/images/48a9f136ea89bf27bae5f3e2927291ac-cuenta-cards-lg.png";